<template>
  <div
    class="combat_matchRow_table"
    :class="[
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : '',
      sportCompetitionType,
    ]"
    v-show="currThemeObj"
  >
    <span class="table_group">
      <span
        class="table_title"
        v-if="tableData && tableData.tableHead.length > 0"
      >
        <span
          class="tableHeader_cell"
          v-for="cell in tableData.tableHead"
          :key="cell.key"
          :style="{ width: cell.widthPer ? cell.widthPer : 0 }"
          v-text="cell.name"
        ></span>
      </span>
      <span class="table_main" v-if="tableData && tableData.list.length > 0">
        <span class="customTable">
          <span
            class="matchItem"
            v-for="(matchItem, mIndex) in tableData.list"
            :key="matchItem.key"
          >
            <template
              v-if="currModeName === 'column3-matchIndex-matchType-playerInfor'"
            >
              <span class="matchItem_index" v-text="mIndex + 1"></span>
              <span class="matchItem_type" v-text="matchItem.sign"></span>
              <template v-if="matchItem.home?.schedule_competitor_type">
                <span
                  class="matchItem_playerArea_text"
                  v-text="matchItem.home?.schedule_competitor_type"
                ></span>
              </template>
              <template v-else>
                <span class="teamBase">
                  <span class="matchItem_playerArea">
                    <span
                      class="customTable_row home"
                      :class="currModeName"
                      v-for="rowItem in matchItem.home?.players"
                      :key="rowItem.player_id"
                    >
                      <span class="playerName-playerLogo-playerGender">
                        <span class="playerOther">
                          <span class="teamInfor">
                            <span class="teamLogo">
                              <img
                                :src="
                                  isCountryLogoArr.includes(
                                    sportCompetitionType
                                  )
                                    ? rowItem['country_logo']
                                    : matchItem.home['team_logo']
                                "
                              />
                            </span>
                            <span
                              class="teamName"
                              v-text="
                                _valPerFormatHandler(
                                  isCountryLogoArr.includes(
                                    sportCompetitionType
                                  )
                                    ? rowItem['country_name']
                                    : matchItem.home['team_name']
                                )
                              "
                            ></span>
                          </span>
                          <span
                            class="playerName"
                            :class="
                              currPlayerIds.includes(rowItem['player_id'] + '')
                                ? 'currPlayer'
                                : ''
                            "
                            v-text="
                              _valPerFormatHandler(rowItem['player_name'])
                            "
                            @click="
                              goDetail('CSMeetPlayerDetailIndex', rowItem)
                            "
                          ></span>
                        </span>
                        <span
                          class="playerLogo"
                          :class="[
                            rowItem['player_logo'] ? 'isLogo' : '',
                            rowItem['player_gender'],
                          ]"
                        >
                          <img
                            v-if="rowItem['player_logo']"
                            :src="rowItem['player_logo']"
                          />
                        </span>
                      </span>
                    </span>
                  </span>
                  <span class="teamScore" v-text="matchItem.home?.score"></span>
                </span>
              </template>
              <span class="vsArea">
                <span
                  class="vsRow"
                  v-for="vsNum in matchItem.vsRowNum"
                  :key="vsNum"
                >
                  <span
                    class="vsHome"
                    v-text="matchItem.homeScore_detail[vsNum - 1].periodScore"
                  ></span>
                  <span class="vs" v-text="':'"></span>
                  <span
                    class="vsAway"
                    v-text="matchItem.awayScore_detail[vsNum - 1].periodScore"
                  ></span>
                </span>
              </span>
              <template v-if="matchItem.away?.schedule_competitor_type">
                <span
                  class="matchItem_playerArea_text"
                  v-text="matchItem.away?.schedule_competitor_type"
                ></span>
              </template>

              <template v-else>
                <span class="teamBase">
                  <span class="teamScore" v-text="matchItem.away?.score"></span>
                  <span class="matchItem_playerArea">
                    <span
                      class="customTable_row away"
                      :class="currModeName"
                      v-for="rowItem in matchItem.away?.players"
                      :key="rowItem.player_id"
                    >
                      <span class="playerName-playerLogo-playerGender">
                        <span
                          class="playerLogo"
                          :class="[
                            rowItem['player_logo'] ? 'isLogo' : '',
                            rowItem['player_gender'],
                          ]"
                        >
                          <img
                            v-if="rowItem['player_logo']"
                            :src="rowItem['player_logo']"
                          />
                        </span>
                        <span class="playerOther">
                          <span class="teamInfor">
                            <span class="teamLogo">
                              <img
                                :src="
                                  isCountryLogoArr.includes(
                                    sportCompetitionType
                                  )
                                    ? rowItem['country_logo']
                                    : matchItem.away['team_logo']
                                "
                              />
                            </span>
                            <span
                              class="teamName"
                              v-text="
                                _valPerFormatHandler(
                                  isCountryLogoArr.includes(
                                    sportCompetitionType
                                  )
                                    ? rowItem['country_name']
                                    : matchItem.away['team_name']
                                )
                              "
                            ></span>
                          </span>
                          <span
                            class="playerName"
                            :class="
                              currPlayerIds.includes(rowItem['player_id'] + '')
                                ? 'currPlayer'
                                : ''
                            "
                            v-text="
                              _valPerFormatHandler(rowItem['player_name'])
                            "
                            @click="
                              goDetail('CSMeetPlayerDetailIndex', rowItem)
                            "
                          ></span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </template>
            </template>
          </span>
        </span>
      </span>
    </span>
  </div>
</template>

<script>
// 适用： 羽毛球 团体 本场数据
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'combat_matchRow_table',
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('matchRow_table 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tableData: null,
      currModeName: '',
      renderModeList: [
        {
          modeName: 'column3-matchIndex-matchType-playerInfor',
          sportsIdArr: ['TEN', 'BDM', 'SQU', 'TST'],
        },
      ],
      isCountryLogoArr: ['tennis_chinaOpen'], //国旗从country_logo里面获取的赛事
    }
  },
  computed: {
    currPlayerIds() {
      let currPlayerIds = []
      if (
        this.datas &&
        this.datas.objectInfo &&
        this.datas.objectInfo.length > 0
      ) {
        this.datas.objectInfo[0].playerInfos.forEach((playerItem) => {
          if (playerItem) {
            currPlayerIds.push(playerItem.playerId)
          }
        })
      }
      return currPlayerIds
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      console.debug('matchRow_table ', this.currSportsDetail, this.datas)

      this.$nextTick(() => {
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
            }
          })
        }
        this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
      })
    },
    goDetail(routerName, item, id) {
      console.debug(routerName, item)
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    notDataHandler() {
      this.tableData = {
        tableHead: [],
        list: [],
      }
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      let tableHead = []
      let list = []
      //   const keyArr = ['home', 'away']
      if (data.data.dataList && data.data.dataList.length > 0) {
        // TEN 中网的表头 tableHead
        tableHead = [
          //   这里面name、key和widthPer结构固定，widthPer的值代表宽度占的百分比
          {
            name: '',
            key: 'indexNo',
            widthPer: '4%',
          },
          {
            name: '阶段',
            key: 'stage',
            widthPer: '12%',
          },
          {
            name: '竞赛者',
            key: 'homeInfor',
            widthPer: '35%',
          },
          {
            name: 'vs',
            key: 'detailScore',
            widthPer: '14%',
          },
          {
            name: '竞赛者',
            key: 'awayInfor',
            widthPer: '35%',
          },
        ]

        list = data.data.dataList.map((group, groupIndex) => {
          group.key = `${group.sign}_${groupIndex}`
          group.sign = group.sign
          let vsRowNum = 0
          if (group.home && group.home.score_detail) {
            if (group.home.score_detail.length > vsRowNum) {
              vsRowNum = group.home.score_detail.length
            }
            group.homeScore_detail = group.home.score_detail
          } else {
            group.homeScore_detail = []
          }
          if (group.away && group.away.score_detail) {
            if (group.away.score_detail.length > vsRowNum) {
              vsRowNum = group.away.score_detail.length
            }
            group.awayScore_detail = group.away.score_detail
          } else {
            group.awayScore_detail = []
          }
          group.vsRowNum = vsRowNum
          return group
        })
      }
      console.debug('matchRow_table:', tableHead, list)
      let tableData = {
        tableHead,
        list,
      }

      if (tableData.list.length > 0) {
        this.tableData = tableData
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.combat_matchRow_table {
  /* padding: 1.388vw 0; */
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .table_group {
    width: 100%;
    height: auto;
    .table_title {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      color: var(--mixtmt_table_headerColor);
      width: 100%;
      height: 3.125vw;
      background-color: var(--mixtmt_table_headerBg);
      text-align: center;
      /* .indexTypeWidth {
        width: 4%;
      }
      .matchStage {
        width: 12%;
        text-align: center;
      }
      .playerInfor {
        width: 35%;
        text-align: center;
      } */
    }
    .teamBase {
      width: 35%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .teamInfo {
        width: calc(100% - 6.94vw);
        display: flex;
        display: -webkit-flex;
        align-items: center;
        padding: 0 0.694vw;
        &.home {
          justify-content: flex-end;
          .teamName {
            padding-right: 0.694vw;
          }
        }
        &.away {
          justify-content: flex-start;
          .teamName {
            padding-left: 0.694vw;
          }
        }
      }
      .teamScore {
        width: 6.94vw;
        text-align: center;
        font-weight: bold;
        font-size: 1.11vw;
      }
    }
    .vsArea {
      width: 14%;
      text-align: center;
      font-size: 1.11vw;
      font-weight: bold;
    }
    .table_main {
      position: relative;
      width: 100%;
      height: auto;
      color: var(--mixtmt_greyColor3);
      font-weight: bold;
      .customTable {
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        .matchItem {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          .matchItem_index,
          .matchItem_type {
            font-size: 0.972vw;
            text-align: center;
            color: var(--mixtmt_greyColor3);
          }
          .vsArea {
            .vsRow {
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              font-size: 0.972vw;
              .vsHome,
              .vsAway {
                width: calc(50% - 0.347vw);
              }
              .vsHome {
                text-align: right;
              }
              .vsAway {
                text-align: left;
              }
              .vs {
                width: 0.694vw;
                text-align: center;
              }
            }
          }
          .teamScore {
            font-size: 1.38vw;
          }
          .matchItem_index {
            width: 4%;
          }
          .matchItem_type {
            width: 12%;
          }
          .matchItem_playerArea {
            width: calc(100% - 6.94vw);
            height: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
          }
          .matchItem_playerArea_text {
            width: 35%;
            height: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            font-size: 1.25vw;
          }
        }
      }

      .customTable_row {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        height: 5.55vw;
        padding: 0 0.694vw;
        &.home {
          justify-content: flex-end;
          .playerName-playerLogo-playerGender {
            .playerOther {
              .teamInfor {
                flex-direction: row-reverse;
                .teamName {
                  padding: 0 0.694vw 0 0;
                }
              }
              .playerOther {
                align-items: flex-end;
              }
            }
          }
          .playerName-playerLogo-playerGender-teamLogo-teamName,
          .playerName-playerLogo-playerGender {
            .playerOther {
              .playerName {
                text-align: right;
              }
            }
          }
        }

        .playerName-playerLogo-playerGender-teamLogo-teamName,
        .playerName-playerLogo-playerGender {
          height: 4.16vw;
          width: 25vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .playerLogo {
            position: relative;
            width: 4.16vw;
            height: 4.16vw;
            border-radius: 50%;
            background-size: 100% auto;
            background-position: left 35%;
            background-repeat: no-repeat;
            background-image: var(--mixtmt_default_playerLogo);
            &::before {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 5;
              width: 1.11vw;
              height: 1.11vw;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-position: center;
              /* background-image: var(--mixtmt_gender_male_icon); */
            }
            &::after {
              position: absolute;
              content: '\20';
              bottom: 0;
              right: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              border: 1px solid var(--mixtmt_greyColor5);
            }
            &.F {
              &::before {
                background-image: var(--mixtmt_gender_female_icon);
              }
            }
            &.M {
              &::before {
                background-image: var(--mixtmt_gender_male_icon);
              }
            }
            &.isLogo {
              background-image: none;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
          }
          .playerOther {
            width: calc(100% - 4.16vw);
            padding: 0 0.694vw;
            height: 4.16vw;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;
            .teamInfor {
              width: 100%;
              height: 1.66vw;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .teamLogo {
                width: 2.5vw;
                height: 1.66vw;
                overflow: hidden;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              .teamName {
                padding: 0 0 0 0.694vw;
                font-size: 0.972vw;
                color: var(--mixtmt_greyColor3);
              }
            }
            .playerName {
              margin-top: 0.694vw;
              width: 100%;
              font-size: 0.972vw;
              height: 1.38vw;
              line-height: 1.38vw;
              color: var(--mixtmt_greyColor4);
              text-align: left;
              font-weight: bold;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.currPlayer {
                color: var(--mixtmt_subColor1_1);
              }
            }
          }
        }
        .playerName-playerLogo-playerGender {
          .playerOther {
            justify-content: center;
          }
        }
        .player_number {
          margin: 0 0.694vw;
          width: 3.47vw;
          height: 2.788vw;
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100% 100%;
          color: var(--mixtmt_whiteColor);
          line-height: 2.788vw;
          font-size: 1.11vw;
          text-align: center;
        }
        .player_state {
          width: 6.94vw;
          color: var(--mixtmt_greyColor3);
          font-size: 1.11vw;
          text-align: center;
        }
        .player_birthDate {
          width: 9.72vw;
          color: var(--mixtmt_greyColor3);
          font-size: 1.11vw;
          text-align: center;
        }
        &.column3-matchIndex-matchType-playerInfor {
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            width: 100%;
          }
        }
      }
    }
  }
}

.mixtmt_pc {
  .combat_matchRow_table {
    .table_group {
      .table_title {
        .teamName {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }

      .table_main {
        .customTable_row {
          .playerName-playerLogo-playerGender-teamLogo-teamName,
          .playerName-playerLogo-playerGender {
            .playerOther {
              .playerName {
                &:hover {
                  cursor: pointer;
                  color: var(--mixtmt_subColor1_1);
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
  }
}
#app.mixtmt_pc .combat_matchRow_table {
  &.notJumpDetailPageClass {
    .column3-matchIndex-matchType-playerInfor {
      pointer-events: none;
    }
  }
}
</style>
